import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import NavigationHeader from '../../components/NavigationHeader';
import SectionScrollIndicator from '../../components/SectionScrollIndicator';
import ExperienceHeader from './components/ExperienceHeader';
import ExperienceStats from './components/ExperienceStats';
import ExperienceTimeline from './components/ExperienceTimeline';
import SkillsUsedSection from './components/SkillsUsedSection';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const WorkExperience = () => {
  const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState(true);

  const experiences = [
    {
      id: 1,
      role: "Senior MERN Stack Developer | Technical Consultant",
      company: "Cosmic Info Solution",
      companyType: "agency",
      level: "senior",
      duration: "2023 - Present",
      location: "Surat, IN", // Assuming based on previous
      projectsCompleted: 15,
      responsibilities: [
        "Serve as the primary technical point of contact for clients, leading discovery calls to understand existing business workflows and translate them into actionable software requirements.",
        "Advise clients on digital transformation strategy, recommending how modern web architecture and automation can streamline their operations and improve customer experience.",
        "Own the full project lifecycle, from solution architecture and technical documentation through milestone planning, timeline estimation, and production deployment.",
        "Design scalable frontend and backend architectures on the MERN stack, making key technical decisions on database schema, API structure, and system integrations.",
        "Plan and manage project roadmaps by breaking large engagements into clearly scoped milestones, enabling predictable delivery and transparent client communication.",
        "Handle server management, deployment, and performance optimization for production applications, ensuring reliability and responsiveness post-launch.",
        "Provide ongoing client support and solution consulting after go-live, maintaining long-term technical relationships and identifying opportunities for further improvement."
      ],
      technologies: ['JavaScript', 'React', 'Node.js', 'Express.js', 'MongoDB', 'AWS', 'REST APIs', 'System Architecture'],
      projectLink: false
    },
    {
      id: 2,
      role: "Lead MERN Stack Developer, Project: KiviCare MERN",
      company: "Iqonic Design",
      companyType: "product",
      level: "lead",
      duration: "2021 - 2023",
      location: "Surat, IN",
      projectsCompleted: 1,
      responsibilities: [
        "Started as an Intern for 3 months before being brought onto the team full-time, later going on to lead the ground-up MERN Stack implementation of KiviCare, a clinic and healthcare management product originally built on WordPress and Laravel. Owned the project from requirement analysis through production release, directing architecture, development, and delivery.",
        "Conducted in-depth analysis of the existing KiviCare product and its business workflows to define functional requirements for the new MERN-based implementation.",
        "Designed the overall solution architecture, including database schema (MongoDB/Mongoose), REST API structure, and frontend component architecture in React.js.",
        "Led sprint planning, task breakdown, and code review for the development team, making key technical decisions on state management, API design, and reusable component patterns.",
        "Directed development of core modules including Patient Management, Doctor Management, Appointment Management, Encounter Management, Electronic Medical Records, Billing, Prescriptions, Treatment Planning, Dental Charts, Multi-Clinic Architecture, Role Management, Dashboards, Reports, and Notifications.",
        "Worked closely with product stakeholders to prioritize features and align technical execution with business goals, while maintaining a UI structure consistent with the product's existing WordPress version.",
        "Optimized backend queries and frontend rendering for performance, and planned the production deployment and release process.",
        "Successfully delivered the complete MERN implementation within a one-month timeline, establishing a scalable, maintainable architecture adopted as the foundation for the product's ongoing development."
      ],
      technologies: ['React', 'Node.js', 'Express.js', 'MongoDB', 'Mongoose', 'REST APIs', 'WordPress'],
      projectLink: true
    }
  ];

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsLoading(false);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, []);

  const handleDownloadResume = () => {
    // Mock resume download
    const link = document.createElement('a');
    link.href = '/assets/Dishant_Madariya_Resume.pdf';
    link.download = 'Dishant_Madariya_Resume.pdf';
    link.click();
  };

  const handleExperienceSelect = (experience) => {
    // Navigate to project portfolio with filter
    navigate(`/projects?company=...`);
  };

  // if (isLoading) {
  //   return (
  //     <div className="min-h-screen bg-background flex items-center justify-center">
  //       <div className="text-center">
  //         <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
  //         <p className="text-text-secondary">Loading work experience...</p>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <>
      <Helmet>
        <title>Work Experience - Dishant Madariya | Full Stack Developer</title>
        <meta
          name="description"
          content="Review the professional work experience of Full Stack Developer Dishant Madariya, including MERN stack, WordPress and SaaS product development roles."
        />
        <meta
          name="keywords"
          content="Dishant Madariya experience, work history, full stack developer career, MERN stack developer, professional background"
        />
        <link rel="canonical" href="https://port-folio-three-teal.vercel.app/experience" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <SectionScrollIndicator />

        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
            <ExperienceHeader onDownloadResume={handleDownloadResume} />

            <ExperienceStats experiences={experiences} />

            <ExperienceTimeline
              experiences={experiences}
              onExperienceSelect={handleExperienceSelect}
            />

            <SkillsUsedSection experiences={experiences} />
          </div>
        </main>

        {/* Footer */}
        {/* <footer className="bg-surface border-t border-border py-8">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="flex items-center space-x-2 mb-4 md:mb-0">
                <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
                  <Icon name="Code" size={20} color="white" />
                </div>
                <span className="text-lg font-bold text-text-primary">DevPortfolio</span>
              </div>
              
              <div className="flex items-center space-x-6 text-sm text-text-secondary">
                <span>© {new Date().getFullYear()} All rights reserved</span>
                <div className="flex items-center space-x-4">
                  <a href="https://github.com" className="hover:text-text-primary transition-colors">
                    <Icon name="Github" size={16} />
                  </a>
                  <a href="https://linkedin.com" className="hover:text-text-primary transition-colors">
                    <Icon name="Linkedin" size={16} />
                  </a>
                  <a href="https://twitter.com" className="hover:text-text-primary transition-colors">
                    <Icon name="Twitter" size={16} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer> */}
      </div>
    </>
  );
};

export default WorkExperience;